"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSalesOrderRelease = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class UpdateSalesOrderRelease extends common_1.UpdateAction {
}
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsInt(),
    class_validator_1.Min(1),
    class_validator_1.Max(999)
], UpdateSalesOrderRelease.prototype, "releaseNumber", void 0);
__decorate([
    class_validator_1.IsOptional()
], UpdateSalesOrderRelease.prototype, "dueDate", void 0);
__decorate([
    class_validator_1.IsOptional()
], UpdateSalesOrderRelease.prototype, "shipDate", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsNumber(),
    class_validator_1.Min(0)
], UpdateSalesOrderRelease.prototype, "quantity", void 0);
exports.UpdateSalesOrderRelease = UpdateSalesOrderRelease;
//# sourceMappingURL=update-sales-order-release.action.js.map